/* eslint-disable import/prefer-default-export */
/**
 * Returns the url of the image resource.
 * @param {string|File|Blob} src
 */
export function getImageResource(src) {
  if (!src) {
    return null;
  }
  if (typeof File !== 'undefined' && src instanceof File) {
    return URL.createObjectURL(src);
  }
  if (typeof Blob !== 'undefined' && src instanceof Blob) {
    return URL.createObjectURL(src);
  }

  const stringSrc = src.toString();

  if (
    stringSrc.startsWith('http') ||
    stringSrc.startsWith('blob:') ||
    stringSrc.startsWith('data:')
  ) {
    return stringSrc;
  }

  return `${process.env.VUE_APP_STORAGE_URL}/${stringSrc}`;
}
